export default __webpack_public_path__ + "static/media/Medium's Gloves of the Dark Pact.8a290505.jpg";